/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { get } from "lodash-es";
import { classnames } from "../../utils/text";

import Icon from "../Icon";
import Profile from "../Profile";
import Button from "../Button";

import DeleteIcon from "../../assets/images/icon/x-icon.svg";
import HandOverIcon from "../../assets/images/icon/hand-over-icon.svg";
import CheckIcon from "../../assets/images/icon/check-icon.svg";
import DeniedIcon from "../../assets/images/icon/denied-icon.svg";
import TaskPencilIcon from "../../assets/images/icon/task-pencil-icon.svg";

import ToolTip from "../ToolTip/ToolTip";
import { dateToViewFormatWithDayNameWithTime } from "../../utils/date";

const TaskEmployeeItem = (props) => {
  const { employee, mode, deleteEmployee, isRequester, taskData } = props
  return (
    <>
      <div className={classnames(
        "employee-item",
        `employee-item-${get(employee, 'data.status')}`,
        {
          'employee-item-requester': isRequester
        }
      )} >
        <span className="employee-item-status">
          <Icon className="check-icon" src={CheckIcon}></Icon>
          <Icon className="denied-icon" src={DeniedIcon}></Icon>
          <Icon className="requester-icon" src={TaskPencilIcon}></Icon>
        </span>
        {get(employee, 'approverOrigin', null) && <ToolTip
          className={'hand-over-icon-wrap'}
          position={"bottom"}
          tooltiptext={`${employee.approverOrigin.name}님으로 부터 위임받은 할일`}
        >
          <span className="hand-over-icon"><Icon src={HandOverIcon}></Icon></span>
        </ToolTip>}
        <Profile data={employee}></Profile>
        {
          isRequester && taskData &&
          <span className='signed-time request-time'>
            {dateToViewFormatWithDayNameWithTime(taskData.approvalTarget.createdTime)}
          </span>
        }
        {
          get(employee, 'data.comment') &&
          <span className='signed-comment'>
            {employee.data.comment}
          </span>
        }
        {
          get(employee, 'data.status') === "approved" && employee.data.signedTime &&
          <span className='signed-time approved-time'>
            {dateToViewFormatWithDayNameWithTime(employee.data.signedTime)}
          </span>
        }
        {
          get(employee, 'data.status') === "denied" && employee.data.signedTime &&
          <span className='signed-time denied-time color-red-100'>
            {dateToViewFormatWithDayNameWithTime(employee.data.signedTime)}
          </span>
        }
        {
          mode === 'create' && deleteEmployee &&
          <Button
            className="employee-delete-button"
            color="text"
            onClick={() => deleteEmployee(employee)}
          >
            <Icon src={DeleteIcon}></Icon>
          </Button>
        }
      </div>
    </>
  );
};

export default TaskEmployeeItem;
